import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, finalize, map, catchError, switchMap } from 'rxjs/operators';
import { RegisterContractModificationDTO, ProjectEntityDTO, ResultTypeDTO, ObjectContextDTO, ContractDTO, ValidationResultDTO, ValidationExecutionDTO } from '../../api/plyca-dtos-v2';
import { Observable, of, ObservableInput, forkJoin } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { InterfaceSettings } from '../../api/contract-notice-dto';
import { FormConfig } from '../../components/forms/form.objects';
import { WorkRegisterContractModificationDTO } from '../../api/plyca-dtos';
import { RegisterContractModificationValidations } from './registerContractModification.validation';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';


@Component({
  selector: 'registerContractModification-form',
  // templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
  templateUrl: './registerContractModification.template.html',
  providers: [RegisterContractModificationValidations]
})

export class RegisterContractModificationComponent
  extends BaseFormComponent<RegisterContractModificationDTO, RegisterContractModificationDTO>
  implements OnInit {
  private identifier: string;
  // private formService: FormService;

  // Identificador de incidencia
  private isLvto: boolean; // Si es no lvto.
  private type: string; // Tipo de la incidencia
  private projectIdentifier: string; // Identiificador del expediente
  private contractDivision: string; // Division padre de la incidencia
  private contractId: string; // identificador del contrato
  public contract: ContractDTO;

  private workRegisterContractModification: WorkRegisterContractModificationDTO; // Tarea de la incidencia
  private contexWork: ObjectContextDTO; // Contexto de la tarea de la incidencia

  private enabledEspecificCauseslist: any;
  private enabledOtherCausesList: any;

  params: string;

  @Input()
  project: ProjectEntityDTO;

  constructor(

    public configuration: Configuration,
    private registerContractModificationValidations: RegisterContractModificationValidations,
    elem: ElementRef,
    public router: Router,
    @Optional() protected activatedRoute: ActivatedRoute,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService
  ) {
    super(elem);
  }


  ngOnInit(): void {
    let helpTags = [].concat([HelpType.NEW_REGISTER_CONTRACTMODIFICATION, 'INCIDENCIA_RECO_' + this.type]);

    if (this.task) {
      console.log('INVOCACION DE CONTRACTMODIFICATION DESDE TAREA', this.task);
      this.workRegisterContractModification = this.task.work;
      // this.identifier = this.task.work.registerContractModification.identifier;
      // this.contractId = this.task.work.registerContractModification.contract.identifier;
      this.contract = this.task.work.registerContractModification.contract;
      this.type = this.task.work.registerContractModification.contractModification.alias;

      // ayuda con tarea
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap((taksHelpTags) => {
          helpTags = taksHelpTags.concat(helpTags);
          return this.helpService.showContextHelpObservable(helpTags)
        })));

    } else {
      this.subscribe(
        this.activatedRoute.params
          .pipe(tap(params => (this.identifier = params['id']))))

      this.subscribe(
        this.activatedRoute.queryParams,
        params => {
          this.projectIdentifier = params['projectIdentifier'];
          this.contractDivision = params['contractDivision'];
          this.type = params['type'];

          this.subscribe(
            this.helpService.showContextHelpObservable(helpTags));

          this.contractId = params['contractId'];
          if (this.contractId) {
            this.subscribe(
              this.plycaService.get<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL, this.contractId),
              (contract: ContractDTO) => {
                this.contract = contract;
              }

            );
          }
          // this.contract = params['contract'];
        });
    }
    if (this.type === 'RSC') {
      // Consultamos atributos de carga de causas.
      this.subscribe(this.loadRSCCausesAttributes(), () => super.ngOnInit());
    } else {
      super.ngOnInit()
    }

  }



  private newFormConfig(): FormConfig {
    let formConfig: FormConfig;
    formConfig = new FormConfig('registerContractModifications/registerContractModificationInterfaceSettings_.json', undefined, this.model);
    return formConfig;
  }

  private ignoreError(e: any, channeFormURL: string): ObservableInput<InterfaceSettings> {
    console.error('Error al obtener definicion del formulario ' + channeFormURL);
    return of(undefined);
  }


  createFormConfig(): Observable<FormConfig> {
    // let dto = this.model;
    let baseFormURL = this.getFormSettingURL();
    let registerContractModificationForm: Observable<InterfaceSettings>;
    let registerContractModificationFormURL = 'registerContractModifications/registerContractModificationInterfaceSettings_' + this.type + '.json';
    registerContractModificationForm = this.plycaService.getInterfaceSettings(registerContractModificationFormURL, true).pipe(
      catchError((e: any) => this.ignoreError(e, registerContractModificationFormURL))
    );

    // Datos Comunes 1: Observaciones, Documento es copia original
    let registerContractModificationCommonGroupFormURL = 'registerContractModifications/registerContractModificationGeneralGroupInterfaceSettings.json';
    let registerContractModificationCommonGroup: Observable<InterfaceSettings>;

    registerContractModificationCommonGroup = this.plycaService.getInterfaceSettings(registerContractModificationCommonGroupFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, registerContractModificationCommonGroupFormURL))
    );

    // Panel de levantamiento de la suspension
    let registerContractModificationLVTO_URL = 'registerContractModifications/registerContractModificationInterfaceSettings_LVTO.json';
    let registerContractModificationLVTO: Observable<InterfaceSettings>;

    registerContractModificationLVTO = this.plycaService.getInterfaceSettings(registerContractModificationLVTO_URL).pipe(
      catchError((e: any) => this.ignoreError(e, registerContractModificationLVTO_URL))
    );


    // Panel de importes
    let registerContractModificationBudgetFormURL = 'registerContractModifications/registerContractModificationBudgetInterfaceSettings.json';
    let registerContractModificationBudgetForm: Observable<InterfaceSettings>;

    registerContractModificationBudgetForm = this.plycaService.getInterfaceSettings(registerContractModificationBudgetFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, registerContractModificationBudgetFormURL))
    );

    // Tabla de anualidades
    let registerContractModificationBudgetAccountLinesFormURL = 'registerContractModifications/registerContractModificationBudgetAccountLinesInterfaceSettings.json';
    let registerContractModificationBudgetAccountLinesForm: Observable<InterfaceSettings>;

    registerContractModificationBudgetAccountLinesForm = this.plycaService.getInterfaceSettings(registerContractModificationBudgetAccountLinesFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, registerContractModificationBudgetAccountLinesFormURL))
    );
    // Nuevo adjudicatario. Tabla componentes UTE. Solo para la CSC y SBC.
    let registerContractModificationNewAwardFormURL = 'registerContractModifications/registerContractModificationNewAward.json';
    let registerContractModificationNewAwardForm: Observable<InterfaceSettings>;

    registerContractModificationNewAwardForm = this.plycaService.getInterfaceSettings(registerContractModificationNewAwardFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, registerContractModificationNewAwardFormURL))
    );


    return forkJoin(
      this.plycaService.getInterfaceSettings(baseFormURL),
      registerContractModificationForm, // 0
      registerContractModificationCommonGroup, // 1
      registerContractModificationLVTO, // 2
      registerContractModificationBudgetForm, // 3
      registerContractModificationBudgetAccountLinesForm, // 4
      registerContractModificationNewAwardForm// 5
    ).pipe(
      map((result: InterfaceSettings[]) => {
        let mergedInterfacceSettings = result[0];
        let interfaceToMerge = result[1];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        interfaceToMerge = result[2];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        if (this.isLvto) {
          interfaceToMerge = result[3];
          if (interfaceToMerge) {
            mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
          }
        }
        if (this.type === 'MDC' || this.type === 'PRC' || this.type === 'CSC' || (this.type === 'SBC' && !RegisterContractModificationValidations.isAM(this.model))) {
          interfaceToMerge = result[4]; // budget
          if (interfaceToMerge) {
            mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
          }
        }
        if (this.type === 'MDC' || this.type === 'PRC') {
          interfaceToMerge = result[5]; // budgetAccountLines
          if (interfaceToMerge) {
            mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
          }
        }
        if (this.type === 'CSC' || this.type === 'SBC') {
          interfaceToMerge = result[6]; // new Award
          if (interfaceToMerge) {
            mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
          }
        }
        let formConfig = this.newFormConfig();
        formConfig.interfaceSetting = mergedInterfacceSettings;
        formConfig.isModalWindow = false;
        formConfig.showValidations = true;
        return formConfig;
      }),
      finalize(() => { console.log('Creado') })
    );
    // if que comprueba en el contexto si las anualidades son visibles.
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    // let baseFormURL = this.getFormSettingURL();
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
  }

  getFormSettingURL(): string {
    // Se le concatena el tipo de la incidencia, para abrir la incidencia adecuada
    // return 'registerContractModifications/registerContractModificationInterfaceSettings_' + this.type + '.json';
    return 'registerContractModifications/registerContractModificationInterfaceSettings.json';
  }

  getServiceURL(): string {
    return this.configuration.REGISTER_CONTRACT_MODIFICATIONS_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    if (this.identifier === 'new') {
      return this.identifier + '?projectIdentifier=' + this.projectIdentifier + '&contractDivision=' + this.contractDivision + '&type=' + this.type;
    } else {
      return this.identifier;
    }
  }

  dtoToModel(dto: RegisterContractModificationDTO): Observable<RegisterContractModificationDTO> {
    // SERVIDOR A CLIENTE
    // En las tareas, comentamos el identifier para que baseForm no haga un findOne de la FRCI!!!!
    if (this.task && !dto.contractModification) {
      console.log('INVOCACION DE CONTRACTMODIFICATION DESDE TAREA', this.task);
      dto = this.task.work.registerContractModification;
    }
    if (dto.liftingContractModification) {
      this.isLvto = true;
    }
    if (dto.contractModification.alias) {
      this.type = dto.contractModification.alias;
    }

    /*
  if (dto.contractModification.cause && dto.contractModification.cause.generalCause) {
    let cause = new ContractModificationCauseDTO;
    cause.description = "";
    cause.generalCause = dto.contractModification.cause.generalCause;
    dto.contractModification.cause.generalCause
  }*/

    /*if (this.type === 'PNC') {
      let bean: any;
      bean = dto;
      bean.causesList = new Array<any>();

      let causes = dto.contractModification.generalCause;
      if (causes && causes.length > 0) {
        causes.forEach((cause: MasterDataDTO) =>
          bean.causesList.push(cause)
        );
    }
    }*/
    // Se establecen las configueraciones del conteexto de tarea
    this.setUIConfigurations(dto);
    return of(dto);
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  setUIConfigurations(dto: RegisterContractModificationDTO) {
    // Se inicializa el UI
    dto['ui'] = {};
    dto['ui'].isModeError = false;
    dto['ui'].edition = true;
    dto['ui'].isEditableSupport = false;
    dto['ui'].enabledEspecificCauseslist = this.enabledEspecificCauseslist;
    dto['ui'].enabledOtherCausesList = this.enabledOtherCausesList;
    dto['ui'].selectedProjectOrganizationalSnapshot = new Object();
    dto['ui'].selectedLiftingProjectOrganizationalSnapshot = new Object();

    if (dto?.context && dto.context.configurations['activeTemporayPeriodOrganizationalChange'] && dto.context.configurations['activeTemporayPeriodOrganizationalChange']) {
      dto['ui'].activeTemporayPeriodOrganizationalChange = dto.context.configurations['activeTemporayPeriodOrganizationalChange'].value;
      if (dto['ui'].activeTemporayPeriodOrganizationalChange) {
        dto['ui'].enabledPreviousOrganizationalUnitRegistration = true;
      } else {
        if (dto.previousOrganizationalUnitRegistration !== undefined) {
          //No está activo, pero el campo se ha visualizado en algun monmento: subsanacion
          dto['ui'].enabledPreviousOrganizationalUnitRegistration = false;
        }
      }
    }




    // Se inicializan las configuraciones de tarea
    if (this.workRegisterContractModification && this.workRegisterContractModification.context
      && this.workRegisterContractModification.context.configurations != undefined) {
      this.contexWork = this.workRegisterContractModification.context;

      if (this.contexWork.configurations['screenMode']) {
        if (this.contexWork.configurations['screenMode'].value == 'RECTIFICA' || this.contexWork.configurations['screenMode'].value == 'ANULA') {
          dto['ui'].isModeError = true;
          if (this.contexWork.configurations['screenMode'].value == 'ANULA') {
            dto['ui'].edition = false;
          }
        }
      }

      // Errores
    }

    if (dto.context.configurations && dto.context.configurations.isEditableSupport && dto.context.configurations.isEditableSupport.value) {
      dto['ui'].isEditableSupport = dto.context.configurations.isEditableSupport.value;
    } else {
      dto['ui'].isEditableSupport = false;
    }

    if (this.isLvto) {
      dto['ui'].selectedLiftingProjectOrganizationalSnapshot = dto.liftingProjectOrganizationalSnapshot;
    } else {
      dto['ui'].selectedProjectOrganizationalSnapshot = dto.projectOrganizationalSnapshot;
    }


  }

  modelToDTO(model: RegisterContractModificationDTO): RegisterContractModificationDTO {
    // CLIENTE A SERVIDOR
    if (model.division) {
      model.contractModification.division = model.division;
    }

    // Causas
    /*if (model.contractModification.cause && model.contractModification.cause.generalCause) {
      let cause = new ContractModificationCauseDTO;
      cause.description = "";
      cause.generalCause = model.contractModification.cause.generalCause;
      model.contractModification.cause = cause;
    }*/

    // IMPORTES: Redondeamos los importes.
    if (model.contractModification && model.contractModification.budget) {
      let contractModificationBudget = model.contractModification.budget;
      if (contractModificationBudget.auxAmount) {
        model.contractModification.budget.auxAmount = this.roundDecimals(contractModificationBudget.auxAmount, 2);
      }
      if (contractModificationBudget.budgetVariation) {
        model.contractModification.budget.budgetVariation = this.roundDecimals(contractModificationBudget.budgetVariation, 2);
      }
      if (contractModificationBudget.registerAmountExcludingTaxes) {
        model.contractModification.budget.registerAmountExcludingTaxes = this.roundDecimals(contractModificationBudget.registerAmountExcludingTaxes, 2);
      }
      if (contractModificationBudget.registerTotalTaxes) {
        model.contractModification.budget.registerTotalTaxes = this.roundDecimals(contractModificationBudget.registerTotalTaxes, 2);
      }
      if (contractModificationBudget.registerTotalAmount) {
        model.contractModification.budget.registerTotalAmount = this.roundDecimals(contractModificationBudget.registerTotalAmount, 2);
      }

      if (model.budgetAccountLines) {
        model.budgetAccountLines.forEach(budget => {
          if (budget.budget && budget.budget.totalAmount) {
            budget.budget.totalAmount = this.roundDecimals(budget.budget.totalAmount, 2);
          }
        });
      }
    }


    if (this.type === 'SCN') {
      if (model.contractModification.subcontratedCompany !== undefined) {
        let order = 0;
        model.contractModification.subcontratedCompany.forEach(element => {
          element.order = order;
          order = order + 1;
        });
      }

    }

    model = JSON.parse(
      JSON.stringify(model, (k, v) => (k === '_parent' ? undefined : v))
    );
    if (this.task !== undefined) {
      this.task.work.registerContractModification = model;
    }


    return model;
  }

  getTitle(model: RegisterContractModificationDTO): string {
    if (model) {
      return model.identifier + ' - ';
    } else {
      return 'Nuevo grupo';
    }

  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleIcon = 'fas fa-file-invoice';

    if (this.model && this.model.division && this.model.division.parent && this.model.division.parent.project) {
      headerInfo.project = this.model.division.parent.project;
    }
    if (this.model && this.model.contractModification && this.model.contractModification.name) {
      headerInfo.titleKey = 'Ficha de inscripción de ' + this.model.contractModification.name;
    } else {
      headerInfo.titleKey = 'Ficha de inscripción de incidencia';
    }
    return headerInfo;
  }



  initHeaderActions() {
    this.subscribe(
      this.headerActionsService
        .addAction('Verificar', 'fas fa-check', 'btn-primary', true),
      () => {
        this.validateRegisterContractModification();
      }
    );


    this.subscribe(
      this.headerActionsService
        .addAction('General.save', 'fas fa-save', 'btn-primary', true),
      () => {
        if (this.task !== undefined) {
          this.subscribe(this.saveIfValid(true)); // NO TOCA EL WAITSERVICE.
        } else {
          this.waitService.startWaiting();
          this.subscribe(
            this.validate(false), result => {
              this.waitService.cancelWaiting();
              if (result.result === ResultTypeDTO.ERROR) {
                this.uiService.showConfirmMessage({
                  message: 'Se han detectado errores que impiden la tramitación. ¿Desea guardar la incidencia?',
                  header: 'Confirmacion',
                  icon: 'pi pi-exclamation-triangle',
                  accept: () => {
                    console.log('Grabando incidencia...');
                    // this.processSubscribe(_error);
                    this.waitService.startWaiting();
                    let error = false;
                    this.subscribe(
                      this.save(false).pipe(finalize(() => {
                        if (!error) { this.goToDossierInfo(); }
                      })),


                      (ok) => ({}),
                      (ko) => {
                        error = true;
                        this.uiService.showMessage(
                          'Ha ocurrido un error al intentar guardar.',
                          'Aviso',
                          'errorStyle'
                        )
                        this.waitService.cancelWaiting();
                      }

                    );
                  },
                  reject: () => {

                    console.log('No hace nada...');
                  }
                });
              } else if (result.result === ResultTypeDTO.WARNING) {
                let errMessge = '';
                let errores: Array<ValidationExecutionDTO> = result.errors;
                errMessge = '<br><ul>';
                errores.forEach((errorVal: ValidationExecutionDTO) => {
                  errMessge += '<li>' + errorVal.message + '</li>';
                });
                errMessge += '</ul>';

                this.uiService.showConfirmMessage({
                  message: errMessge,
                  header: 'Confirmacion',
                  icon: 'pi pi-exclamation-triangle',
                  accept: () => {
                    this.waitService.startWaiting();
                    this.subscribe(
                      this.save(false).pipe(
                        finalize(() => {
                          this.goToDossierInfo();
                        })
                      ));
                  },
                  reject: () => {
                    console.log('No hace nada...');
                  }
                });
              } else if (result.result === ResultTypeDTO.OK) {
                this.waitService.startWaiting();
                this.subscribe(
                  this.save(false).pipe(
                    finalize(() => {
                      this.goToDossierInfo();
                    })
                  ));
              }
            },
            error => {
              this.waitService.cancelWaiting();
              this.plycaErrorHandler.showServerError(error);
            }
          )
        }
      }
    );


    this.headerActionsService.addDivider();
    this.addBackAction();
  }

  validateRegisterContractModification() {

    this.subscribe(
      this.validate(), result => {
        if (result.result === ResultTypeDTO.ERROR || result.result === ResultTypeDTO.WARNING) {
          this.formPlycaRef.manageFormException(result);
        } else if (result.result === ResultTypeDTO.OK) {
          this.uiService.showMessage(
            'Se ha verificado correctamente.',
            'Información',
            'successStyle'
          );
        }
      })
  }


  private setFormConfig(_registerContractModification: RegisterContractModificationDTO) {
    let newForm = {} as FormConfig;
    newForm.interfaceSetting = this.formConfig.interfaceSetting;
    newForm.model = _registerContractModification;
    newForm.functions = this.formConfig.functions;
    newForm.isModalWindow = this.formConfig.isModalWindow;
    newForm.showValidations = this.formConfig.showValidations;
    this.loadFunctions(newForm);
    this.formConfig = newForm;
  }

  showConfirmMessageError(_registerContactModification: RegisterContractModificationDTO) {
    this.uiService.showConfirmMessage({

      // 'No se podrá iniciar la tramitación de la incidencia, hasta que se completen todos los datos obligatorios',
      message: this.translateService.instant('ContractModification.message_error_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.goToDossierInfo();
        console.log('Saliendo...');
      }
    });
  }

  showConfirmMessage(_registerContactModification: RegisterContractModificationDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(
          this.plycaService.startRegisterContractModification(_registerContactModification)
            .pipe(
              finalize(() => {
                this.waitService.cancelWaiting();
              })
            )
          , () => {
            this.goToDossierInfo();
          },
          () => {
            console.log('Error');
          }
        );
      },
      reject: () => {
        this.goToDossierInfo();
        console.log('Saliendo...');
      }
    });
  }

  goToDossierInfo() {
    this.waitService.startWaiting();
    this.router.navigate(['dossierInfo/' + this.model.division.parent.project.identifier], {
      queryParams: { component: 'CONTRACTSAYMAD' }
    });
  }

  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');

    _formConfig.functions.push({
      identifier: 'enabledTaxRate',
      fn: this.registerContractModificationValidations.enabledTaxRate
    });


    /*_formConfig.functions.push({
      identifier: 'isVisibleBudgetModification',
      fn: this.registerContractModificationValidations.isVisibleBudgetModification
    });*/

    /*_formConfig.functions.push({
      identifier: 'isVisibleBudget',
      fn: this.registerContractModificationValidations.isVisibleBudget
    });*/
    _formConfig.functions.push({
      identifier: 'isVisibleBudgetRegisterTaxRate',
      fn: this.registerContractModificationValidations.isVisibleBudgetRegisterTaxRate
    });

    // VISIBILIDAD DATOS COMUNES INCIDENCIAS REGISTRO.

    _formConfig.functions.push({
      identifier: 'isVisibleDOUEPublicationDate',
      fn: this.registerContractModificationValidations.isVisibleDOUEPublicationDate
    });

    _formConfig.functions.push({
      identifier: 'isVisibleNotPlannedPCAPCause',
      fn: this.registerContractModificationValidations.isVisibleNotPlannedPCAPCause
    });

    _formConfig.functions.push({
      identifier: 'isContractorCuase',
      fn: this.registerContractModificationValidations.isContractorCuase
    });

    _formConfig.functions.push({
      identifier: 'isEntrepreneurCause',
      fn: this.registerContractModificationValidations.isEntrepreneurCause
    });

    _formConfig.functions.push({
      identifier: 'causeAttributableToContractor',
      fn: this.registerContractModificationValidations.causeAttributableToContractor
    });

    _formConfig.functions.push({
      identifier: 'clearExtensionData',
      fn: this.registerContractModificationValidations.clearExtensionData
    });

    _formConfig.functions.push({
      identifier: 'isVisibleRegisterDataLvto',
      fn: this.registerContractModificationValidations.isVisibleRegisterDataLvto
    });

    _formConfig.functions.push({
      identifier: 'isVisibleRegisterData',
      fn: this.registerContractModificationValidations.isVisibleRegisterData
    });

    _formConfig.functions.push({
      identifier: 'isCBAM',
      fn: this.registerContractModificationValidations.isCBAM
    });

    _formConfig.functions.push({
      identifier: 'isVisibleInAMAndCSC',
      fn: this.registerContractModificationValidations.isVisibleInAMAndCSC
    });


    _formConfig.functions.push({
      identifier: 'isLvto',
      fn: this.registerContractModificationValidations.isLvto
    });

    /*_formConfig.functions.push({
      identifier: 'isVisibleBudgetAccountLines',
      fn: this.registerContractModificationValidations.isVisibleBudgetAccountLines
    });*/

    _formConfig.functions.push({
      identifier: 'isVisibleAmountsBudgetAccountLines',
      fn: this.registerContractModificationValidations.isVisibleAmountsBudgetAccountLines
    });

    _formConfig.functions.push({
      identifier: 'isVisibleBudgetVariation',
      fn: this.registerContractModificationValidations.isVisibleBudgetVariation
    });

    _formConfig.functions.push({
      identifier: 'isVisibleAuxAmount',
      fn: this.registerContractModificationValidations.isVisibleAuxAmount
    });

    _formConfig.functions.push({
      identifier: 'isProjectReplyca',
      fn: this.registerContractModificationValidations.isProjectReplyca
    });

    _formConfig.functions.push({
      identifier: 'isVisibleOrganic',
      fn: this.registerContractModificationValidations.isVisibleOrganic
    });

    _formConfig.functions.push({
      identifier: 'isVisibleFunctionalEconomic',
      fn: this.registerContractModificationValidations.isVisibleFunctionalEconomic
    });

    _formConfig.functions.push({
      identifier: 'isVisibleOrganicEditorConfig',
      fn: this.registerContractModificationValidations.isVisibleOrganicEditorConfig
    })

    _formConfig.functions.push({
      identifier: 'isVisibleFunctionalEconomicEditorConfig',
      fn: this.registerContractModificationValidations.isVisibleFunctionalEconomicEditorConfig
    })

    _formConfig.functions.push({
      identifier: 'isVisibleAmountsBudgetAccountLinesEditorConfig',
      fn: this.registerContractModificationValidations.isVisibleAmountsBudgetAccountLinesEditorConfig
    });

    _formConfig.functions.push({
      identifier: 'visibleTaxRateType',
      fn: this.registerContractModificationValidations.visibleTaxRateType
    });

    _formConfig.functions.push({
      identifier: 'isVisibleDOUEData',
      fn: this.registerContractModificationValidations.isVisibleDOUEData
    });

    _formConfig.functions.push({
      identifier: 'isDelayExecution',
      fn: this.registerContractModificationValidations.isDelayExecution
    });

    _formConfig.functions.push({
      identifier: 'isOtherBreach',
      fn: this.registerContractModificationValidations.isOtherBreach
    });

    _formConfig.functions.push({
      identifier: 'clearPenaltyData',
      fn: this.registerContractModificationValidations.clearPenaltyData
    });

    _formConfig.functions.push({
      identifier: 'getPenaltyType',
      fn: this.registerContractModificationValidations.getPenaltyType
    });

    _formConfig.functions.push({
      identifier: 'isVisibleBudgetAuxTaxRate',
      fn: this.registerContractModificationValidations.isVisibleBudgetAuxTaxRate
    });

    _formConfig.functions.push({
      identifier: 'isCSC',
      fn: this.registerContractModificationValidations.isCSC
    });

    _formConfig.functions.push({
      identifier: 'isMDC',
      fn: this.registerContractModificationValidations.isMDC
    });

    _formConfig.functions.push({
      identifier: 'isPRC',
      fn: this.registerContractModificationValidations.isPRC
    });

    _formConfig.functions.push({
      identifier: 'getAuxAmountCSC',
      fn: this.registerContractModificationValidations.getAuxAmountCSC
    });

    _formConfig.functions.push({
      identifier: 'contractorResponability',
      fn: this.registerContractModificationValidations.contractorResponability
    });

    _formConfig.functions.push({
      identifier: 'existDisqualification',
      fn: this.registerContractModificationValidations.existDisqualification
    });

    _formConfig.functions.push({
      identifier: 'addEspecificCauses',
      fn: this.registerContractModificationValidations.addEspecificCauses
    });

    _formConfig.functions.push({
      identifier: 'addOtherCauses',
      fn: this.registerContractModificationValidations.addOtherCauses
    });

    _formConfig.functions.push({
      identifier: 'isEditableEditorConfigSCN',
      fn: this.registerContractModificationValidations.isEditableEditorConfigSCN
    });

    _formConfig.functions.push({
      identifier: 'isVisibleInAMAndMDCAndPRC',
      fn: this.registerContractModificationValidations.isVisibleInAMAndMDCAndPRC
    });

    _formConfig.functions.push({
      identifier: 'updatePymeSCN',
      fn: this.registerContractModificationValidations.updatePymeSCN
    });

    _formConfig.functions.push({
      identifier: 'enabledAddRemoveRowsSCN',
      fn: this.registerContractModificationValidations.enabledAddRemoveRowsSCN
    });

    _formConfig.functions.push({
      identifier: 'visibleContractExtension',
      fn: this.registerContractModificationValidations.visibleContractExtension.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'editableDurationMonthPRC',
      fn: this.registerContractModificationValidations.editableDurationMonthPRC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.registerContractModificationValidations.loadOrganizationalSnapshotData
    });

    _formConfig.functions.push({
      identifier: 'loadLiftingOrganizationalSnapshotData',
      fn: this.registerContractModificationValidations.loadLiftingOrganizationalSnapshotData
    });

    _formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.registerContractModificationValidations.changeProjectOrganizationalSnapshot
    });

    _formConfig.functions.push({
      identifier: 'changeLiftingProjectOrganizationalSnapshot',
      fn: this.registerContractModificationValidations.changeLiftingProjectOrganizationalSnapshot
    });

    _formConfig.functions.push({
      identifier: 'visiblePreviousOrganizationalUnitRegistration',
      fn: this.registerContractModificationValidations.visiblePreviousOrganizationalUnitRegistration
    });


    _formConfig.functions.push({
      identifier: 'visibleLiftingPreviousOrganizationalUnitRegistration',
      fn: this.registerContractModificationValidations.visibleLiftingPreviousOrganizationalUnitRegistration
    });





  }

  loadRSCCausesAttributes(): Observable<any> {
    // this.subscribe(
    return forkJoin([
      this.plycaService.getAttributeValue(
        'CAUSAS_RSC_GEN_OTR',
        this.params
      ).pipe(catchError((error: any) => {
        console.log(error)
        return of(undefined)
      }))
      ,
      this.plycaService.getAttributeValue(
        'CAUSAS_RSC_GEN_ESP',
        this.params
      ).pipe(catchError((error: any) => {
        console.log(error)
        return of(undefined)
      }))
    ]
    ).pipe(
      tap(([res1, res2]) => {
        if (res1) {
          let x = res1;
          // comprobar si hay lotes
          if (x && x.values && x.values.length > 0) {
            if (x.values[0].columns !== undefined && x.values[0].columns.CAUSAS_RSC_GEN_OTR != null) {
              this.enabledOtherCausesList = x.values[0].columns.CAUSAS_RSC_GEN_OTR.value;
            }
          }
        }
        if (res2) {
          let x = res2;
          if (x && x.values && x.values.length > 0) {
            if (x.values[0].columns !== undefined && x.values[0].columns.CAUSAS_RSC_GEN_ESP != null) {
              this.enabledEspecificCauseslist = x.values[0].columns.CAUSAS_RSC_GEN_ESP.value;
            }
          }
        }
        this.waitService.cancelWaiting();
      }
      ))
    /*err => {
      console.log(err)
      this.waitService.cancelWaiting();
    })*/


  }

}
